import Textfield from './Textfield'
import Select from './Select';
import DateTimePicker from './DataTimePicker';
import Checkbox from './Checkbox';
import Button from './Button';
import AutoComplete from './Autocomplete';
import ActionButton from './ActionButton';
import Popup from './ModelPopUp'
import RadioButton from "./RadioButton";
import RadioButtonMultiple from "./RadioButton/RadioButtonMultiple"
import LoadingButton from "./LoadingButton"
import Grid from "./Grid";
const Controls = {
  Textfield,
  Select,
  DateTimePicker,
  Checkbox,
  Button,
  AutoComplete,
  ActionButton,
  Popup,
  RadioButton,
  Grid,
  RadioButtonMultiple,
  LoadingButton
};

export default Controls;